import React, { useState, useEffect } from "react"

const useIsIntersecting = (ref, options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false)

  useEffect(() => {
    if (ref.current) {
      let handleIntersect = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsIntersecting(true)

            return
          }

          setIsIntersecting(false)
        })
      }

      let observer = new IntersectionObserver(handleIntersect, options)

      observer.observe(ref.current)
    }
  }, [])

  return isIntersecting
}

export default useIsIntersecting
